const styles = {
  buttonOpen: {
    minWidth: '40px',
    padding: 0,
    margin: '15px 0 0',
    '&:hover': { backgroundColor: 'transparent' },
  },
  buttonIcon: {
    fontSize: '2.5rem',
  },
  popover: {
    '& .css-fmd3pk-MuiPaper-root-MuiPopover-paper': { width: '300px' },
  },
  innerBox: {
    padding: '10px',
  },
};

export default styles;
